<template>
  <div>
    <v-row class="align-center border-b--thin pa-2">

      <v-menu offset-y :close-on-content-click="false" min-width="280px">
        <template v-slot:activator="{ on }">
          <v-btn
          text
          outlined
          v-on="on"
          >
            <v-icon small>mdi-filter</v-icon>
            <div class="ml-1">
              Filter
            </div>
            <span v-if="activeFilterCount > 0">
              &nbsp;|&nbsp;
              <span class="color1--text">
                {{ activeFilterCount }}
              </span>
            </span>
            <v-icon small>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-card class="">
          <v-layout justify-center align-center class="backgroundCard pa-2">
            <v-btn outlined small @click="clearFilters">
              Clear
            </v-btn>
            <v-spacer></v-spacer>
            Filters
            <v-spacer></v-spacer>
            <v-btn color="color1" class="white--text" small>
              Accept
            </v-btn>
          </v-layout>
          <div class="c-hr"></div>
          <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.date = !filters.active.date">
            <v-icon small v-if="filters.active.date" color="color1">
              mdi-checkbox-marked-outline
            </v-icon>
            <v-icon small v-else>
              mdi-checkbox-blank-outline
            </v-icon>
            &nbsp;
            Date:
          </v-layout>
          <div class="c-hr"></div>
          <v-expand-transition>
            <div v-show="filters.active.date">
              <div style="background: #f7fafc;" class="pt-1 pb-1">
                <v-select
                  v-model="filters.date.mainSelect"
                  class="ma-2 input-slot-thin-border caption"
                  :items="dateFilters"
                  dense
                  hide-details
                  solo
                ></v-select>
                <!-- DATE OPTIONS -->
                <div v-if="filters.date.mainSelect === 'is in the last'">
                  <v-layout class="pl-2 pr-2" style="width: 12em;">
                      <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                      &nbsp;
                      <c-input :value.sync="filters.date.isInTheLast_input" class="crx-box-input mr-2" style="flex: 0 0 3em;"></c-input>
  
                      <v-select
                        v-model="filters.date.isInTheLast_select"
                        class="input-slot-thin-border caption"
                        style="flex: 0 0 5em;"
                        :items="['days', 'months']"
                        dense
                        hide-details
                        solo
                      ></v-select>
                  
                  </v-layout>
                </div>
                <div v-else-if="filters.date.mainSelect === 'is equal to'">
                  <v-layout class="pl-2 pr-2" align-center>
                    <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                    &nbsp;
                    <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                  </v-layout>
                </div>
                <div v-else-if="filters.date.mainSelect === 'is between'">
                  <v-layout class="pl-2 pr-2" align-center>
                    <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                    &nbsp;
                    <c-date :date.sync="filters.date.date1" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                    and
                    <c-date :date.sync="filters.date.date2" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                  </v-layout>
                </div>
                <div v-else-if="filters.date.mainSelect === 'is after'" class="">
                  <v-layout class="pl-2 pr-2" align-center>
                    <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                    &nbsp;
                    <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                  </v-layout>
                </div>
                <div v-else-if="filters.date.mainSelect === 'is on or after'" class="">
                  <v-layout class="pl-2 pr-2" align-center>
                    <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                    &nbsp;
                    <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                  </v-layout>
                </div>
                <div v-else-if="filters.date.mainSelect === 'is before'" class="">
                  <v-layout class="pl-2 pr-2" align-center>
                    <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                    &nbsp;
                    <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                  </v-layout>
                </div>
                <div v-else-if="filters.date.mainSelect === 'is on or before'" class="">
                  <v-layout class="pl-2 pr-2" align-center>
                    <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                    &nbsp;
                    <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                  </v-layout>
                </div>
                
              </div>
            </div>
          </v-expand-transition>
          <div class="c-hr"></div>
          <!-- ITEM FLAGS -->
          <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.item_flags = !filters.active.item_flags">
            <v-icon small v-if="filters.active.item_flags" color="color1">
              mdi-checkbox-marked-outline
            </v-icon>
            <v-icon small v-else>
              mdi-checkbox-blank-outline
            </v-icon>
            &nbsp;
            Item flags:
          </v-layout>
          <div class="c-hr"></div>
          <v-expand-transition>
            <div v-show="filters.active.item_flags">
              <div style="background: #f7fafc;" class="pt-1 pb-1 pl-4 pr-4">
                <div class="subheading font-weight-bold">
                  Item flags
                </div>

                <v-checkbox
                v-model="filters.item_flags.raw_material"
                label="Raw material"
                color="blue"
                ></v-checkbox>

                <v-checkbox
                v-model="filters.item_flags.product"
                label="Finished product"
                color="green"
                ></v-checkbox>

                <v-checkbox
                v-model="filters.item_flags.disposable"
                label="Disposable"
                color="red darken-3"
                ></v-checkbox>
                
                
              </div>
            </div>
          </v-expand-transition>
          <!-- END ITEM FLAGS -->
        </v-card>
      </v-menu>
      <v-spacer></v-spacer>
      <v-btn text outlined class="mr-2" color="green" text-color="white">
        <json-excel
        :fetch="fetchData">
          <v-icon small color="green" class="mr-2">mdi-file-excel</v-icon>
          Download excel
        </json-excel>
      </v-btn>
    </v-row>
    

    <!-- TABLE -->
    <table class="final-table th-no-padding lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="30px">
        <col width="15px">
        <col width="10px">
      </colgroup>

      <tr class="unselectable">
        <c-table-header
        title="Name"
        code="name"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
      
        <c-table-header
        title="Quantity"
        code="quantity"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Inventory count"
        code="inventory_count"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
      </tr>

      <row
      v-for="(item, i) in items" 
      :key="item.id"
      :item="item"
      :searchFilters="filters.search"
      @click.native="clickRow(item)"
      ></row>

    </table>

    <!-- PAGINATION -->
    <v-layout align-center justify-center class="pa-2">

      <v-btn
      text
      :disabled="page <= 0"
      @click="goToFirstPage()"
      class="mr-2"
      >
        1
      </v-btn>

      <v-btn
      text
      :disabled="page <= 0"
      @click="goToPreviousPage()"
      class="mr-2"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <template v-if="pagination.rowCount > 0">
        <span class="font-weight-bold">
          {{ page + 1 }}
        </span>
      </template>
      <template v-else>
        1
      </template>

      <v-btn
      :disabled="page >= pagination.pages - 1"
      text
      @click="goToNextPage()"
      class="ml-2 mr-2"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>

      <v-btn
      text
      :disabled="!(page < (pagination.pages - 1))"
      @click="goToLastPage()"
      class="mr-2"
      >
        {{ pagination.pages || 1 }}
      </v-btn>

      <v-spacer></v-spacer>

      |

      <c-s-list-items-per-page :rowsPerPage.sync="filters.rowsPerPage" class="mr-2"></c-s-list-items-per-page>

    </v-layout>
        
  </div>
</template>

<script>
import JsonExcel from 'vue-json-excel'
import axios from 'axios'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListBindings'
import Row from './row'

export default {
  components: {
    Row,
    JsonExcel
  },
  mixins: [ServerListController, ServerListBindings],
  data () {
    return {
      page: 0,
      filters: {
        rowsPerPage: 15,
        sortCol: 'name',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        item_flags: {
          product: false,
          raw_material: false,
          disposable: false
        },
        search: {
          id: '',
          name: ''
        },
        active: {
          item_flags: false,
          date: false
        },
        categories: []
      },
      dateFilters: ['is in the last', 'is equal to', 'is between', 'is after', 'is on or after', 'is before', 'is on or before'],
    }
  },
  methods: {
    async fetchData(){
      var response = await this.loadAPI()
      const encodedFilters = btoa(JSON.stringify(this.filters))
      var response = await this.$axios.get(`/accounting/finished-products?filters=${encodedFilters}&page=all`)
      var rows = response.data.rows
      var new_rows = rows.map(item => {
        console.log(item)
        var quantity = item.quantity
        var unit_of_measure = 'units'
        if (item.definition.metric === 0) {
          unit_of_measure = 'units'
        }
        if (item.definition.metric === 1) {
          quantity = quantity / 1000 // convert to L
          unit_of_measure = 'litre'
        }
        if (item.definition.metric === 2) {
          quantity = quantity / 1000 / 1000 // convert to KGs
          unit_of_measure = 'kg'
        }
        if (item.definition.metric === 3) {
          quantity = quantity / 1000 // convert to M
          unit_of_measure = 'metre'
        }

        return {
          inventory_item_id: item.id,
          name: item.name,
          quantity: quantity,
          unit_of_measure: unit_of_measure
        }

        /* var hmetric = this.$crx.metrics.humanizeDBMetric(item.quantity, item.definition.metric)
        item.quantity = hmetric.quantity
        console.log(hmetric) */
      })
      console.log(new_rows)
      return new_rows
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        axios.all([
          this.$axios.get(`/accounting/finished-products?filters=${encodedFilters}&page=${this.page}`)
        ])
        .then(axios.spread((_response) => {
          var rows = _response.data.rows
          console.log(rows)
          this.pagination.rowCount = _response.data.count
          this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
          if (this.items.length > rows.length) {
            this.currentIndex = 0
          }
          this.items = rows
        }))
        .then(() => resolve())
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
        .then(() => {
          this.isLoading = false
        })
      })
    }, 150, {leading: true})
  },
  created () {
    this.loadAPI()
  }
}
</script>